import React from 'react'
import {Icon} from '@salesforce/retail-react-app/app/components/shared/ui'

const ChronoIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" width="40" height="40" {...props}>
            <path
                d="M20.157 9.83958C26.7395 9.83958 32.0761 15.1761 32.0761 21.7586C32.0761 27.4105 28.1123 32.2439 22.6734 33.4113C22.6779 33.4093 22.7243 35.0337 22.7243 35.0337C29.0419 33.8189 33.6761 28.2678 33.6761 21.7586C33.6761 14.2924 27.6232 8.23958 20.157 8.23958V9.83958Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.7081 21.7585C23.7081 23.4447 22.533 24.8569 20.957 25.2199V35.1587H19.357V25.22C17.7809 24.8571 16.6056 23.4449 16.6056 21.7585C16.6056 19.797 18.1954 18.2072 20.1568 18.2072C22.1182 18.2072 23.7081 19.797 23.7081 21.7585ZM22.1081 21.7585C22.1081 20.6807 21.2346 19.8072 20.1568 19.8072C19.0791 19.8072 18.2056 20.6807 18.2056 21.7585C18.2056 22.8364 19.0793 23.7105 20.1568 23.7105C21.2344 23.7105 22.1081 22.8364 22.1081 21.7585Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.04 0H15.2741C14.8323 0 14.4741 0.358172 14.4741 0.8C14.4741 1.24183 14.8323 1.6 15.2741 1.6H19.3572V4.01769C15.6932 4.18007 12.3179 5.45273 9.55938 7.50741L8.23774 5.83304L6.98184 6.82437L8.32019 8.51991C4.68581 11.7717 2.39844 16.498 2.39844 21.7585C2.39844 31.5662 10.3494 39.5177 20.1569 39.5177C29.9644 39.5177 37.9153 31.5662 37.9153 21.7585C37.9153 16.3953 35.5378 11.5874 31.7792 8.33116L33.1288 6.62133L31.8729 5.63001L30.5241 7.33876C27.8091 5.38331 24.5196 4.17571 20.9572 4.01771V1.6H25.04C25.4818 1.6 25.84 1.24183 25.84 0.8C25.84 0.358172 25.4818 0 25.04 0ZM20.1569 5.6C29.0808 5.6 36.3153 12.8345 36.3153 21.7585C36.3153 30.6826 29.0807 37.9177 20.1569 37.9177C11.2331 37.9177 3.99844 30.6826 3.99844 21.7585C3.99844 12.8345 11.2329 5.6 20.1569 5.6Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ChronoIcon
